<form [formGroup]="form" (ngSubmit)="save()" novalidate>
  <div class="modal-header">
    <h2 class="modal-title" id="ks-template-modal-title">{{ title() }}</h2>

    <button type="button" class="ks-modal-close" aria-label="Cerrar" (click)="cancel()">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="ks-form-group">
      <label class="ks-label" for="ks-template-code">Código</label>

      <input
        id="ks-template-code"
        type="text"
        class="ks-field ks-mono"
        formControlName="code"
        autocomplete="off"
        spellcheck="false"
        placeholder="BANK_ACCOUNT"
        [attr.aria-invalid]="invalid('code') ? 'true' : null"
        [attr.aria-describedby]="invalid('code') ? 'ks-template-code-error' : 'ks-template-code-hint'" />

      @if (invalid('code')) {
        <p class="ks-field-error" id="ks-template-code-error" role="alert">
          <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
          Usa solo letras, dígitos, guion y guion bajo (máx. 50).
        </p>
      } @else {
        <p class="ks-field-hint" id="ks-template-code-hint">
          @if (isEdit()) {
            El código identifica la plantilla y no se puede cambiar.
          } @else {
            Código único de la plantilla. No se podrá cambiar después.
          }
        </p>
      }
    </div>

    <div class="ks-form-group">
      <label class="ks-label" for="ks-template-name">Nombre</label>

      <input
        id="ks-template-name"
        type="text"
        class="ks-field"
        formControlName="name"
        autocomplete="off"
        placeholder="Cuenta bancaria"
        [attr.aria-invalid]="invalid('name') ? 'true' : null"
        [attr.aria-describedby]="invalid('name') ? 'ks-template-name-error' : null" />

      @if (invalid('name')) {
        <p class="ks-field-error" id="ks-template-name-error" role="alert">
          <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
          Escribe un nombre de máximo 150 caracteres.
        </p>
      }
    </div>

    <div class="ks-form-group">
      <label class="ks-label" for="ks-template-description">Descripción</label>

      <textarea
        id="ks-template-description"
        class="ks-field"
        formControlName="description"
        rows="3"
        placeholder="Para qué sirve esta plantilla (opcional)"
        [attr.aria-invalid]="invalid('description') ? 'true' : null"
        [attr.aria-describedby]="invalid('description') ? 'ks-template-description-error' : null"></textarea>

      @if (invalid('description')) {
        <p class="ks-field-error" id="ks-template-description-error" role="alert">
          <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
          La descripción admite máximo 500 caracteres.
        </p>
      }
    </div>

    <div class="ks-form-group">
      <span class="ks-label" id="ks-template-image-label">Imagen</span>

      <div class="ks-upload">
        <span class="ks-upload__preview" aria-hidden="true">
          @if (preview()) {
            <img [src]="preview()" alt="" />
          } @else if (file()) {
            <i class="bi bi-file-earmark-pdf"></i>
          } @else if (currentImage()) {
            <img [src]="currentImage()" alt="" />
          } @else {
            <i class="bi bi-image"></i>
          }
        </span>

        <div class="ks-upload__body">
          <input
            id="ks-template-file"
            type="file"
            class="ks-upload__input"
            [accept]="accept"
            aria-describedby="ks-template-file-hint"
            (change)="onFileChange($event)" />

          <label class="ks-btn ks-btn--glass ks-btn--sm" for="ks-template-file">
            <i class="bi bi-upload" aria-hidden="true"></i>
            {{ currentImage() || file() ? 'Cambiar archivo' : 'Elegir archivo' }}
          </label>

          @if (file()) {
            <p class="ks-upload__name">
              {{ file()!.name }}
              <button
                type="button"
                class="ks-icon-btn ks-icon-btn--danger ks-upload__clear"
                aria-label="Quitar el archivo seleccionado"
                (click)="clearFile()">
                <i class="bi bi-x-lg" aria-hidden="true"></i>
              </button>
            </p>
          }

          @if (fileError()) {
            <p class="ks-field-error" role="alert">
              <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
              {{ fileError() }}
            </p>
          } @else {
            <p class="ks-field-hint" id="ks-template-file-hint">
              JPG, PNG o PDF, hasta 5 MB. Se sube al guardar.
            </p>
          }
        </div>
      </div>
    </div>

    <fieldset class="ks-switches">
      <legend class="ks-label">Opciones</legend>

      <label class="ks-switch ks-switch--row" for="ks-template-qr">
        <input
          id="ks-template-qr"
          type="checkbox"
          role="switch"
          class="ks-switch__input"
          formControlName="generateQr"
          aria-describedby="ks-template-qr-hint" />

        <span class="ks-switch__track" aria-hidden="true">
          <span class="ks-switch__thumb"></span>
        </span>

        <span class="ks-switch__text">
          <span class="ks-switch__title">Generar código QR</span>
          <span class="ks-switch__hint" id="ks-template-qr-hint">
            La app ofrece un QR con los datos de la credencial creada desde esta plantilla.
          </span>
        </span>
      </label>

      @if (isEdit()) {
        <label class="ks-switch ks-switch--row" for="ks-template-status">
          <input
            id="ks-template-status"
            type="checkbox"
            role="switch"
            class="ks-switch__input"
            formControlName="status"
            aria-describedby="ks-template-status-hint" />

          <span class="ks-switch__track" aria-hidden="true">
            <span class="ks-switch__thumb"></span>
          </span>

          <span class="ks-switch__text">
            <span class="ks-switch__title">Activa</span>
            <span class="ks-switch__hint" id="ks-template-status-hint">
              Solo las plantillas activas se pueden usar en la app y en los prerellenados.
            </span>
          </span>
        </label>
      }
    </fieldset>
  </div>

  <div class="modal-footer">
    <button type="button" class="ks-btn ks-btn--glass" (click)="cancel()">Cancelar</button>
    <button type="submit" class="ks-btn ks-btn--primary">
      <i class="bi bi-check-lg" aria-hidden="true"></i>
      Guardar
    </button>
  </div>
</form>
